module.exports = __webpack_public_path__ + "static/media/pause.f1a4d4eb.svg";